import { EstateStatus } from 'components/atoms/AdminEstateStatus/EstateStatus';
import { CellProps } from 'react-table';
import { AdminEstateTableRow, EstateStatusCellProps } from '../AdminProfileListingTable.types';

const AdminTableEstateStatusCell = ({ value }: CellProps<AdminEstateTableRow, EstateStatusCellProps>) => {
  return <EstateStatus estateStatus={value} />;
};

export { AdminTableEstateStatusCell };
